'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('../../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../../button/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../../dialog/index');

var _index4 = _interopRequireDefault(_index3);

var _index5 = require('../../flex-box/index');

var _iconButton = require('../../icon-button/icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _index6 = require('../../icon/index');

var _index7 = _interopRequireDefault(_index6);

var _index8 = require('../../title/index');

var _index9 = _interopRequireDefault(_index8);

var _withDevice = require('../../with-device/with-device');

var _withDevice2 = _interopRequireDefault(_withDevice);

var _chartLegend = require('../chart-legend/chart-legend');

var _chartLegend2 = _interopRequireDefault(_chartLegend);

var _withChartLegend = require('../with-chart-legend');

var _withChartLegend2 = _interopRequireDefault(_withChartLegend);

var _withZoom = require('../with-zoom');

var _withZoom2 = _interopRequireDefault(_withZoom);

require('./chart-container.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getElementsIds = function getElementsIds() {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var idKey = arguments[1];
  return elements.map(function (element) {
    return element[idKey];
  });
};

var ChartContainer = function (_React$Component) {
  _inherits(ChartContainer, _React$Component);

  function ChartContainer(props) {
    _classCallCheck(this, ChartContainer);

    var _this = _possibleConstructorReturn(this, (ChartContainer.__proto__ || Object.getPrototypeOf(ChartContainer)).call(this, props));

    _this.state = {
      isMobileLegendVisible: false,
      triggerDialogClose: false
    };

    _this.onMouseWheel = _this.onMouseWheel.bind(_this);
    return _this;
  }

  _createClass(ChartContainer, [{
    key: 'onMouseWheel',
    value: function onMouseWheel(e) {
      // cross-browser wheel delta
      var zoom = this.props.zoom;


      if (zoom) {
        var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));

        if (delta < 0) {
          zoom.onZoomOut();
        } else {
          zoom.onZoomIn();
        }
      }

      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, {
    key: 'renderLegend',
    value: function renderLegend() {
      var _props = this.props,
          legend = _props.legend,
          device = _props.device;

      return _react2.default.createElement(_chartLegend2.default, {
        data: legend.elements,
        isPhone: device.isPhone,
        labelKey: legend.labelKey,
        onSelectAll: legend.toggleAllElements,
        onToggle: legend.toggleElement
      });
    }
  }, {
    key: 'renderMobileLegend',
    value: function renderMobileLegend() {
      var _this2 = this;

      var _state = this.state,
          isMobileLegendVisible = _state.isMobileLegendVisible,
          triggerDialogClose = _state.triggerDialogClose;


      if (!isMobileLegendVisible && !triggerDialogClose) {
        return null;
      }

      return _react2.default.createElement(
        _index4.default,
        {
          state: 'warning',
          triggerClose: triggerDialogClose,
          footer: _react2.default.createElement(
            _index2.default,
            { onClick: function onClick() {
                return _this2.setState({ triggerDialogClose: true });
              } },
            'Close'
          ),
          onCloseHandler: function onCloseHandler() {
            return _this2.setState({ isMobileLegendVisible: false, triggerDialogClose: false });
          }
        },
        _react2.default.createElement(
          _index5.Flex,
          { alignSelf: 'flex-start', gutter: 'none', margin: 'none' },
          this.renderLegend()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          renderChildren = _props2.renderChildren,
          device = _props2.device,
          _props2$legend = _props2.legend,
          legend = _props2$legend === undefined ? {} : _props2$legend,
          legendCols = _props2.legendCols,
          chartCols = _props2.chartCols,
          title = _props2.title,
          zoom = _props2.zoom;

      /*
        If new filters are implmented (other than legend),
        they must be applied to filteredElements as well,
        or passed to the renderChildren as another kind of filter.
      */

      var elements = legend.elements,
          idKey = legend.idKey,
          filteredElements = legend.filteredElements;

      var legendEnabled = Boolean(elements && filteredElements);
      var isPhone = device.isPhone;

      var chartProps = {
        elementsIds: getElementsIds(elements, idKey),
        filteredElementsIds: getElementsIds(filteredElements, idKey),
        zoom: zoom ? zoom.value : 1,
        onMouseWheel: zoom ? this.onMouseWheel : function () {
          return null;
        }
      };

      var classes = (0, _classnames2.default)('chart-container', className);

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          _index5.Flex,
          { align: 'center', justify: 'space-between', background: 'light', gutter: 'xx-large', margin: 'none' },
          _react2.default.createElement(
            _index9.default,
            { color: 'darker', density: 'cozy', level: '5' },
            title
          ),
          isPhone && legendEnabled && _react2.default.createElement(
            _index2.default,
            { onClick: function onClick() {
                return _this3.setState({ isMobileLegendVisible: true });
              } },
            'Filter',
            _react2.default.createElement(_index7.default, { name: 'filter', color: 'secondary' })
          ),
          zoom && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_iconButton2.default, { onClick: zoom.onZoomOut, shape: 'circle', icon: 'zoom-out' }),
            _react2.default.createElement(_iconButton2.default, { onClick: zoom.onReset, shape: 'circle', icon: 'actual-size' }),
            _react2.default.createElement(_iconButton2.default, { onClick: zoom.onZoomIn, shape: 'circle', icon: 'zoom-in' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'chart-container__content' },
          !isPhone ? _react2.default.createElement(
            _index5.Flex,
            { gutter: 'none', margin: 'none' },
            _react2.default.createElement(
              _index5.Box,
              { sm: legendEnabled ? chartCols : '12' },
              renderChildren(chartProps)
            ),
            legendEnabled && _react2.default.createElement(
              _index5.Box,
              { sm: legendCols },
              this.renderLegend()
            )
          ) : renderChildren(chartProps)
        ),
        legendEnabled && this.renderMobileLegend()
      );
    }
  }]);

  return ChartContainer;
}(_react2.default.Component);

ChartContainer.propTypes = {
  title: _propTypes2.default.string,
  className: _propTypes2.default.string,
  legend: _propTypes2.default.shape({
    idKey: _propTypes2.default.string.isRequired,
    labelKey: _propTypes2.default.string.isRequired,
    elements: _propTypes2.default.arrayOf(_withChartLegend.elementsPropType).isRequired,
    filteredElements: _propTypes2.default.arrayOf(_withChartLegend.elementsPropType).isRequired,
    toggleElement: _propTypes2.default.func.isRequired,
    toggleAllElements: _propTypes2.default.func.isRequired
  }),
  legendCols: _propTypes2.default.oneOf(['1', '2', '3', '4']),
  chartCols: _propTypes2.default.oneOf(['8', '9', '10', '11', '12']),
  renderChildren: _propTypes2.default.func.isRequired,
  zoom: _propTypes2.default.shape({
    value: _propTypes2.default.number.isRequired,
    onZoomIn: _propTypes2.default.func.isRequired,
    onZoomOut: _propTypes2.default.func.isRequired,
    onReset: _propTypes2.default.func.isRequired
  }),
  device: _propTypes2.default.object
};

ChartContainer.defaultProps = {
  legendCols: '4',
  chartCols: '8'
};

exports.default = (0, _withZoom2.default)((0, _withChartLegend2.default)((0, _withDevice2.default)(ChartContainer)));